module.exports = __webpack_public_path__ + "static/sponsors_preview.36aef21e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/navigation/sponsors_preview.jpg
// module id = 693
// module chunks = 213534597649335